<script>
import ChatService from "@/services/ChatService";
import {colorText} from "@/constant/listCommon";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      isLoading: false,
      defaultDataTag: {
        id: "",
        title: "",
        color: "",
        active: false,
        createdDate: ""
      },

      validation: {
        title: [
          {
            required: true,
            message: "Không để trống trường này!", trigger: "blur",
          }
        ],
      },
    }
  },

  watch: {},

  created() {

  },

  methods: {
    colorText() {
      return colorText
    },

    handleClose() {
      this.$emit("closeDialog");
      this.resetForm();
      // this.resetData();
      // this.handleAnimationButtonAddByIndex(this.currentQuestionIndex);
    },

    handleSaveForm() {
      this.$refs["defaultDataTag"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          this.sendUpdateTag();
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.$refs["defaultDataTag"].resetFields();
      this.defaultDataTag = {};
    },

    sendUpdateTag() {
      ChatService.tagService.update(this.defaultDataTag)
          .then(res => {
            const data = res.data.data;
            this.$message({message: res.data.message, type: "success"});
            this.$emit("success", data);
            this.resetForm();
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    initialDataUpdate(data) {
      console.log(data);
      this.defaultDataTag = {
        id: data.id,
        title: data.title,
        color: data.color,
        date: data.date,
        active: data.active,
      };
    }
  }
}
</script>

<template>
  <div>
    <section>
      <el-dialog
          :before-close="handleClose"
          :visible.sync="isOpen"
          :show-close="true"
          width="25%"
          class="create_dialog"
      >
        <template #title>
          <div class="title_dialog">
            <span>Chỉnh sửa thẻ</span>
          </div>
        </template>

        <el-form :model="defaultDataTag" :rules="validation" ref="defaultDataTag">
          <section class="dialog_body">
            <el-row>
              <el-col :span="24">
                <div class="wrapper_input">
                  <el-form-item label="Tên emotion: " prop="title">
                    <el-input
                        placeholder="Nhập tiêu đề"
                        prefix-icon="el-icon-edit"
                        v-model="defaultDataTag.title"
                        type="textarea"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="wrapper_input" style="display: flex; justify-content: center">
                  <el-color-picker
                      v-model="defaultDataTag.color"
                      :predefine="colorText()"
                      color-format="hex"
                  />
                </div>
              </el-col>
            </el-row>
          </section>
        </el-form>

        <section slot="footer">
          <hr/>
          <el-button @click="handleClose" icon="el-icon-circle-close" type="danger">
            Hủy bỏ
          </el-button>
          <el-button type="success" @click="handleSaveForm()" icon="el-icon-circle-check" :loading="isLoading">
            Lưu
          </el-button>
        </section>
      </el-dialog>
    </section>
  </div>
</template>

<style scoped lang="scss">
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.label_dialog {
  margin-bottom: 4px;
  display: block;
  font-weight: 500;
  font-family: Arial, sans-serif;
}
</style>